export function heroSlideViewport(slide) {
	return slide?.viewport === "mobile" ? "mobile" : "desktop";
}

export function heroSlidesForViewport(slides, viewport) {
	if (!Array.isArray(slides)) {
		return [];
	}
	const want = viewport === "mobile" ? "mobile" : "desktop";
	return slides.filter((slide) => heroSlideViewport(slide) === want);
}
